module.exports = __webpack_public_path__ + "static/media/1500.d8a34b2d.jpg";